import { mapGetters } from "vuex";
import { TTMJ } from "@/store/enums";

export default {
  state: {
    balaWT1Passage: "",
    balaWT2Passage: "",
    balliProgress: 0,
    balliSections: [
      { name: "Introduction", path: { name: "balliHome" }, progress: 0 },
      { name: "Self-Efficacy", path: { name: "ability" }, progress: 0 },
      { name: "Motivation", path: { name: "balliAttitude" }, progress: 0 },
      {
        name: "Self-Regulation",
        path: { name: "balliRegulation" },
        progress: 0
      },
      { name: "Grit", path: { name: "balliGrit" }, progress: 0 }
    ],
    balaProgress: 0,
    balaSections: [
      { name: "Reading Task Introduction", path: "/bala", progress: 0 },
      {
        task: "Reading Task 1",
        name: "The Big Sister",
        shortName: "The Big Sister",
        path: { name: "balaRT1Intro" },
        sectionProgress: { Understanding: 0, Questions: 0 },
        progress: 0
      },
      {
        task: "Reading Task 2",
        name: "The Eagle Owl: A Strong, Silent Hunter",
        shortName: "The Eagle Owl",
        path: { name: "balaRT2Intro" },
        sectionProgress: { Understanding: 0, Questions: 0 },
        progress: 0
      },
      {
        task: "Reading Task 3",
        name: "Do Bats Really Drink Blood?",
        shortName: "Bats",
        path: { name: "balaRT3Intro" },
        sectionProgress: { Understanding: 0, Questions: 0 },
        progress: 0
      },
      {
        task: "Reading Task 4",
        name: "Helping Out on the Family Farm",
        shortName: "Family Farm",
        path: { name: "balaRT4Intro" },
        sectionProgress: { Understanding: 0, Questions: 0 },
        progress: 0
      },
      {
        task: "Reading Task 5",
        name: "Marilyn Bell and Her Historic Swim",
        shortName: "Marilyn Bell",
        path: { name: "balaRT5Intro" },
        sectionProgress: { Understanding: 0, Questions: 0 },
        progress: 0
      },
      {
        name: "Writing Task Introduction",
        path: { name: "balaWritingIntro" },
        progress: 0
      },
      {
        task: "Writing Task 1",
        name: "Is Social Media Mostly Good or Bad for Young People?",
        shortName: "Social Media",
        path: { name: "balaWT1Intro" },
        sectionProgress: { Response: 0, Rating: 0, Planning: 0, Question: 0 },
        progress: 0
      },
      {
        task: "Writing Task 2",
        name: "Global Warming",
        shortName: "Global Warming",
        path: { name: "balaWT2Intro" },
        sectionProgress: { Response: 0, Rating: 0, Planning: 0, Question: 0 },
        progress: 0
      }
    ],
    ttmjProgress: 0,
    ttmjSections: [
      { name: "Introduction", path: { name: "t2mejr-intro" }, progress: 0 },
      { name: "Task List", path: { name: "t2mejr-setup" }, progress: 0 },
      {
        name: "Oral Reading Fluency",
        path: { name: "t2mejr-orf" },
        progress: 0
      },
      {
        name: "Pattern Reasoning",
        path: { name: "t2mejr-pattern" },
        progress: 0
      },
      {
        name: "Picture Description",
        path: { name: "t2mejr-pic" },
        progress: 0
      },
      { name: "Working Memory", path: { name: "t2mejr-workmem" }, progress: 0 },
      { name: "Elision", path: { name: "t2mejr-ellision" }, progress: 0 },
      { name: "Story Retell", path: { name: "t2mejr-retell" }, progress: 0 }
    ]
  },
  getters: {
    progressBalli(state: any) {
      return state.balliProgress;
    },
    progressBala(state: any) {
      return state.balaProgress;
    },
    progressTTMJ(state: any) {
      return state.ttmjProgress;
    },
    balaWT1Passage(state: any) {
      return state.balaWT1Passage;
    },
    balaWT2Passage(state: any) {
      return state.balaWT2Passage;
    },
    balliSections(state: any) {
      return state.balliSections;
    },
    balaSections(state: any) {
      return state.balaSections;
    },
    ttmjSections(state: any) {
      return state.ttmjSections;
    }
  },
  mutations: {
    setBalaWT1Passage(state: any, passage: any) {
      state.balaWT1Passage = passage;
    },
    setBalaWT2Passage(state: any, passage: any) {
      state.balaWT2Passage = passage;
    },
    progressBalli(state: any, numQuestionsCompleted: number) {
      state.balliProgress += numQuestionsCompleted;
    },
    progressBala(state: any, progress: number) {
      state.balaProgress += progress;
    },
    progressTTMJ(state: any, progress: number) {
      state.ttmjProgress += progress;
    },
    markBalliComplete(state: any, section: string) {
      if (section == "Ability") {
        state.balliSections[1].progress = 100;
      } else if (section == "Attitude") {
        state.balliSections[2].progress = 100;
      } else if (section == "Regulation") {
        state.balliSections[3].progress = 100;
      } else if (section == "Grit") {
        state.balliSections[4].progress = 100;
      } else if (section == "Intro") {
        state.balliSections[0].progress = 100;
      }
    },
    markTTMJComplete(state: any, section: string) {
      if (section == TTMJ.ORF) {
        state.ttmjSections[2].progress = 100;
      } else if (section == TTMJ.PATREASON) {
        state.ttmjSections[3].progress = 100;
      } else if (section == TTMJ.PICTURE) {
        state.ttmjSections[4].progress = 100;
      } else if (section == TTMJ.WORKMEM) {
        state.ttmjSections[5].progress = 100;
      } else if (section == TTMJ.ELISON) {
        state.ttmjSections[6].progress = 100;
      } else if (section == TTMJ.STORY) {
        state.ttmjSections[7].progress = 100;
      }
      if (state.ttmjSections[0].progress != 100) {
        state.ttmjSections[0].progress = 100;
        state.ttmjSections[1].progress = 100;
      }
      state.ttmjProgress += 17; // 100 divided by 6 tasks
    },
    markBalaComplete(state: any, section: string) {
      if (section == "Reading Task - Intro") {
        state.balaSections[0].progress = 100;
      } else if (section == "Reading Task 1 - Understanding") {
        state.balaSections[1].sectionProgress.Understanding = 100;
      } else if (section == "Reading Task 1 - Questions") {
        state.balaSections[1].sectionProgress.Questions = 100;
      } else if (section == "Reading Task 2 - Understanding") {
        state.balaSections[2].sectionProgress.Understanding = 100;
      } else if (section == "Reading Task 2 - Questions") {
        state.balaSections[2].sectionProgress.Questions = 100;
      } else if (section == "Reading Task 3 - Understanding") {
        state.balaSections[3].sectionProgress.Understanding = 100;
      } else if (section == "Reading Task 3 - Questions") {
        state.balaSections[3].sectionProgress.Questions = 100;
      } else if (section == "Reading Task 4 - Understanding") {
        state.balaSections[4].sectionProgress.Understanding = 100;
      } else if (section == "Reading Task 4 - Questions") {
        state.balaSections[4].sectionProgress.Questions = 100;
      } else if (section == "Reading Task 5 - Understanding") {
        state.balaSections[5].sectionProgress.Understanding = 100;
      } else if (section == "Reading Task 5 - Questions") {
        state.balaSections[5].sectionProgress.Questions = 100;
      } else if (section == "Writing Task - Intro") {
        state.balaSections[6].progress = 100;
      } else if (section == "Writing Task 1 - Response") {
        state.balaSections[7].sectionProgress.Response = 100;
      } else if (section == "Writing Task 1 - Rating") {
        state.balaSections[7].sectionProgress.Rating = 100;
      } else if (section == "Writing Task 1 - Planning") {
        state.balaSections[7].sectionProgress.Planning = 100;
      } else if (section == "Writing Task 1 - Question") {
        state.balaSections[7].sectionProgress.Question = 100;
      } else if (section == "Writing Task 2 - Response") {
        state.balaSections[8].sectionProgress.Response = 100;
      } else if (section == "Writing Task 2 - Rating") {
        state.balaSections[8].sectionProgress.Rating = 100;
      } else if (section == "Writing Task 2 - Planning") {
        state.balaSections[8].sectionProgress.Planning = 100;
      } else if (section == "Writing Task 2 - Question") {
        state.balaSections[8].sectionProgress.Question = 100;
      }
    },
    addBalaProgress(state: any, p: { section: string; progress: number }) {
      if (p.section == "Reading Task 1") {
        state.balaSections[1].progress += p.progress;
      } else if (p.section == "Reading Task 2") {
        state.balaSections[2].progress += p.progress;
      } else if (p.section == "Reading Task 3") {
        state.balaSections[3].progress += p.progress;
      } else if (p.section == "Reading Task 4") {
        state.balaSections[4].progress += p.progress;
      } else if (p.section == "Reading Task 5") {
        state.balaSections[5].progress += p.progress;
      } else if (p.section == "Writing Task 1") {
        state.balaSections[7].progress += p.progress;
      } else if (p.section == "Writing Task 2") {
        state.balaSections[8].progress += p.progress;
      }
    }
  },
  actions: {
    updateBalaProgress(
      { commit }: any,
      p: { section: string; subsection: string }
    ) {
      let progressBoost = p.section.includes("Writing") ? 25 : 50;
      commit("markBalaComplete", `${p.section} - ${p.subsection}`);
      commit("addBalaProgress", {
        section: p.section,
        progress: progressBoost
      });

      // there are 18 subsections (excluding intros), each subsection add 5.6 progress
      commit("progressBala", 5.6);
    }
  }
};
